import React from "react";
import styled from "styled-components";
import Header from "../header/header";
import StaticFooter from "../footer/footer-static";

const Container = styled.div`
	width: 90%;
	max-width: 1200px;
	margin: auto;
	min-height: 50vh;
	@media (min-width: 768px) {
		width: 80%;
	}
`;

const Title = styled.h2`
	font-weight: bold;
	font-size: 32px;
	margin-top: 32px;
	margin-bottom: 8px;
`;

const p = styled.p`
	font-weight: normal;
	font-size: 17px;
	margin: 0;
	margin-bottom: 32px;
`;

const IntumescentCoatings = () => (
	<div>
		<Container>
			<Header />
			<a href="/" alt="home">
				&#8592; Back to Home
			</a>
			<Title>Intumescent Coatings</Title>
			<p>
				Intumescent paint is sprayed or hand applied to steel to protect it for
				up to 120 minutes.
				<br />
				The coating is white in colour, with the texture of orange peel and
				comes either water or solvent based.
				<br />
				The coating is applied to a pre-determined thickness based on the size
				of the steels and is checked during spraying using an Elcometer.
				Humidity and temperature are critical and are checked daily.
				<br />
				<br />
				When steel reaches a critical temperature it can buckle or collapse, the
				intumescent coating in the event of fire will expand up to 50 times its
				original thickness, reducing the heat on the steel, giving people time
				to evacuate the area.
				<br />
				<br />
				All our Intumescent works are backed by a FIRAS conformity certificate,
				giving both client and customer total piece of mind.
			</p>
		</Container>
		<StaticFooter />
	</div>
);

export default IntumescentCoatings;



// WEBPACK FOOTER //
// ./src/components/page/intumescent-coatings.js